// controllers
import { ProductController, UserController } from "controllers";
import { useEffect, useState } from "react";

// components
import { ObjectTagsInput } from "shared/components/bulma/tags-input";

// redux
import { useSelector } from 'react-redux';
import { selectCountry } from '../../../../hyc-store/reducers/countries/countriesReducer';

const CustomerSearchInput = ({ status, value, ...props }) => {
    const TAG_KEY_TEXT = 'tagLabel';
    const TAG_KEY_VALUE = 'email';

    const options = { maxTags: 1 };

    const [initialCustomer, setInitialCustomer] = useState();

    const country = useSelector(selectCountry);

    const data = async (search) => {
        let customers = [];

        if (search !== "" && search.length > 1) {
            customers = await ProductController.getUsersByQuery(search, 20, country);
        }

        for (const customer of customers) {
            customer[TAG_KEY_TEXT] = `${customer.full_name} - ${customer.email}`;
        }

        return customers;
    }

    useEffect(() => {
        const getInitialCustomer = async () => {
            if (!value) {
                setInitialCustomer();
                return;
            }

            const customer = await UserController.getUserByField('email', value);
            if (customer) {
                customer[TAG_KEY_TEXT] = `${customer.full_name} - ${customer.email}`;
                setInitialCustomer(customer)
            }
        }

        if (value !== initialCustomer?.email) {
            getInitialCustomer();
        }
    });

    return (
        <ObjectTagsInput {...props}
            data={data} options={options}
            value={initialCustomer}
            itemText={TAG_KEY_TEXT} itemValue={TAG_KEY_VALUE} />
    );
}

export { CustomerSearchInput };
